import {Component, inject, signal, ChangeDetectionStrategy} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDrawerMode, MatSidenavModule} from '@angular/material/sidenav';
import {SidenavService } from '../../shared/services/sidenav-service';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';

import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth/services/auth-service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'


interface SubItem{
  label : string;
  route ?: string,
  right?:string|null
}

interface MenuItem {
  label : string;
  icon : string;
  route ?: string,
  submenu ?: SubItem[]
  right?:string[]
}

@Component({
  selector: 'app-sidebar-component',
  imports: [
    MatSidenavModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    RouterLink,
    RouterLinkActive,
    MatMenuModule,
    CommonModule,
    RouterOutlet
],
  templateUrl: './sidebar-component.html',
  styleUrl: './sidebar-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})



export class SidebarComponent {
  readonly open = signal<boolean>(false);
  readonly currentSubMenuIndex = signal<number>(-1);

  readonly sidenavDim = signal<number>(50);
  readonly profilDim = signal<number>(32);
  readonly showUsername = signal<boolean>(false);
  readonly panelOpenState = signal(false);
  sidebarType = signal<MatDrawerMode>('side')
  subItemMenuOption = {prevIndex : -1, cpt : 0}
  sidenavState = inject(SidenavService)
  authUser = inject(AuthService).getCurrentUser()

  opened = signal<boolean>(true);

  color = ""

  constructor(private breakPoint : BreakpointObserver){
    this.breakPoint.observe([Breakpoints.Small, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait])
    .subscribe((res) =>{
      console.log(res);
      if(res.breakpoints[Breakpoints.Small] || res.breakpoints[Breakpoints.HandsetLandscape] ||  res.breakpoints[Breakpoints.HandsetPortrait]){
         this.opened.update(val => false)
        this.sidebarType.update(val => 'over')

        if(this.open())
          this.sidenavDim.update(val => 250)
        else
          this.sidenavDim.update(val => 0)
      }else{
        this.opened.update(val => true)
        this.sidebarType.update(val => 'side')
        if(this.open())
          this.sidenavDim.update(val => 250)
        else
          this.sidenavDim.update(val => 50)
      }
    })
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.color = localStorage.getItem('currentSygmaSiteColor')!
  }

  menuItems = signal<MenuItem[]>([
    {
      label : 'Dashboard',
      icon : 'dashboard',
      route : '/home',
    },
    {
      label : 'Production',
      icon : 'shield_with_heart',
      submenu : [
        {
          label : 'Nouvelle affaire', 
          route : '/assure',
          right : 'assurances'
        },
        {
          label : 'Avenant', 
          route : '/avenant',
          right : 'assurances'
        }
      ],
      right : ['assurances']
    },
    {
      label : 'Collaborateurs',
      icon : 'badge',
      route : '/collaborateurs',
      right : ['collaborateurs']
    },
    {
      label : 'Groupes',
      icon : 'add_business',
      route : '/groupes',
      right : ['groupes']
    },
    {
      label : 'Bureaux',
      icon : 'desktop_windows',
      route : '/bureaux',
      right : ['sites']
    },
    {
      label : 'Utilisateurs',
      icon : 'groups_3',
      route : '/users',
      right : ['users']
    },
    {
      label : 'Profils',
      icon : 'admin_panel_settings',
      route : '/profil',
      right : ['profils']
    },
    {
      label : 'Compagnie',
      icon : 'assured_workload',
      route : '/compagnie',
      right : ['compagnies']
    },
    {
      label : 'Ravitaillement & Stocks',
      icon : 'inbox_text_share',
      submenu : [
        {
          label : 'Ravitaillement',
          route : '/distribution',
          right : 'distribution'
        },
        {
          label : 'Stock des Groupes',
          route : '/stock_groupes',
          right : 'stock_groupes'
        },
        {
          label : 'Stock des Bureaux',
          route : '/stock_sites',
          right : 'stock_sites'
        }
      ],
      right : ['distribution', 'stock_groupes', 'stock_sites']
    },
  ])

  ngAfterViewInit(): void {
    this.sidenavState.state.subscribe((res) => {
      this.open.update(val => res)

      if(!this.opened() && this.open())
        this.opened.update(val => true)
      else if(this.sidebarType() == 'over' && !this.open())
        this.opened.update(val => false)

      this.showUsername.update(val => res)
      this.profilDim.update(val => res?100:32)
      this.sidenavDim.update(val => res?250:50);

    })
  }

  openSubMenu(index : number){
    this.subItemMenuOption.cpt++
    this.subItemMenuOption.prevIndex = index

    if(this.subItemMenuOption.cpt>1 && index == this.subItemMenuOption.prevIndex){
      this.currentSubMenuIndex.update(val => -1)
      this.subItemMenuOption.cpt = 0
      this.subItemMenuOption.prevIndex = -1
    }else{
      this.currentSubMenuIndex.update(val => index)
    }
  }

  checkRights(rights : string[] = []) : boolean{
    let state = false
    rights.forEach(item => {
      if(this.authUser.user.profil[item]){
        state = true
        return;
      }
    })

    return state
  }

  ngOnDestroy(): void {
    //this.sidenavState.state.complete()
  }
}
